module.exports = __webpack_public_path__ + "img/logo.cfcdfcfe.svg";